import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/dbSelector';
import { SEAT_PURCHASE_STATUS_PURCHASED } from '%paysera_seat_selection/js/seatSelection/config/constants';

const selectAllPurchasedSeats = createSelector(
    orm,
    dbSelector,
    ({ Seat }) => Seat.filter({ purchaseStatus: SEAT_PURCHASE_STATUS_PURCHASED }).toModelArray(),
);

export default selectAllPurchasedSeats;
